module.exports = __webpack_public_path__ + "static/media/card-icon-04.591295c0.svg";